export default __webpack_public_path__ + "static/media/invBack3.cb28943d.jpeg";